import Field, { FieldTypes } from './field.class';
import { cloneDeep, isEqual, snakeCase } from 'lodash';

export class SimpleCrudController {
  // bindings
  protected service;
  protected translations;
  protected fields: Field[];
  protected forms;

  // locals
  protected originalList: Object[];
  protected list;
  protected newModel;
  protected showNewForm: Boolean = false;
  protected showEditForm: Boolean = false;
  protected saving: Boolean = false;
  public snakeCase: Function = snakeCase;
  /*@ngInject */
  constructor(private $timeout) {}
  $onInit() {
    if (!this.fields || this.fields.length == 0) {
      if (!this.fields) {
        this.fields = [];
      }
      this.fields.push(new Field());
    }
    this.resetNewModel();
    this.refreshData();
  }
  refreshData() {
    if (this.service) {
      this.service.query(
        data => {
          this.list = [];
          this.originalList = data.map(model => this.mapModel(model));
          // console.info('originalList', this.originalList);
          this.$timeout(() => {
            this.list = data;
          }, 0);
        },
        error => {
          console.error('err', error);
        }
      );
    } else {
      console.error('trying to refresh data without proper service');
    }
  }
  mapModel(model) {
    let mapped = {};

    this.fields.forEach(
      field => (mapped[field.name] = cloneDeep(model[field.name]))
    );
    return mapped;
  }
  resetNewModel() {
    this.newModel = {};
    this.fields.forEach(
      field => (this.newModel[field.name] = field.type === 'array' ? [] : '')
    );
  }
  addNew() {
    this.showNewForm = true;
    this.resetNewModel();
  }
  isDataChanged() {
    const changedElements = this.getChangedElements();
    return changedElements.length > 0;
  }
  protected getChangedElements() {
    return this.list.filter((element, index) => this.isChanged(element, index));
  }

  isChanged(element, index) {
    // console.log('is changed, element', element, 'index', index, 'orig', this.originalList[index], '\nfields', this.fields);

    const changedFields = this.fields
      .filter(f => !f.removeOnSave)
      .filter(
        field =>
          !isEqual(element[field.name], this.originalList[index][field.name])
      );
    // console.log('is changed', changedFields);
    return changedFields.length > 0;
  }
  hideNewForm() {
    this.resetNewModel();
    this.showNewForm = false;
  }
  hideEditForm() {
    this.resetNewModel();
    this.showEditForm = false;
  }
  saveNew() {
    this.saving = true;
    // console.log(this.newModel);
    let toSave = Object.assign(this.newModel);
    this.hideNewForm();
    this.service.save(
      toSave,
      res => {
        console.log('ok', res);
        this.refreshData();
        this.saving = false;
      },
      err => {
        console.error('err', err);
        this.saving = false;
      }
    );
  }
  saveEdit() {
    this.saving = true;
    // console.log(this.newModel);
    this.fields.forEach(field => {
      if (field.removeOnSave) {
        this.newModel[field.name] = undefined;
      }
    });
    let toSave = Object.assign(this.newModel);
    this.hideEditForm();
    this.service.update(
      toSave,
      res => {
        // console.log('ok', res);
        this.refreshData();
        this.saving = false;
      },
      err => {
        console.error('err', err);
        this.saving = false;
      }
    );
  }
  saveChanges() {
    var saving = [];
    this.getChangedElements().forEach((element, index) => {
      // console.log('save element', element, this.forms[index].$valid);
      if (this.forms[index].$valid) {
        saving.push(this.save(element));
      }
    });
    if (saving.length == 0) {
      // TODO alert invalid data can't be saved
    }
    return Promise.all(saving)
      .then(saveResult => {
        // console.log('save results', saveResult);
        this.refreshData();
      })
      .catch(err => {
        console.error('error saving', err);
      });
  }
  reset() {
    this.list.forEach((element, index) => {
      this.fields.forEach(field => {
        element[field.name] = this.originalList[index][field.name];
      });
    });
  }
  save(element) {
    return new Promise((resolve, reject) => {
      element.$update((...args) => resolve(args), (...args) => reject(args));
    });
  }
  delete(element) {
    element.$delete(
      (...args) => this.refreshData(),
      (...args) => console.error
    );
  }
  validateNthField(formIndex, name) {
    let form = this.forms[formIndex];
    // console.log('validateNthField', formIndex, name, form, this.forms);
    return this.validateField(form, name, true);
  }

  validateField(form, name, ignoreSubmitted = false) {
    // console.log('validateField', name, form);
    let required =
      (form.$submitted || ignoreSubmitted) &&
      form[name].$error.required &&
      form[name].$pristine;
    let invalid = !form[name].$pristine && form[name].$invalid;
    return {
      invalid: required || invalid,
      fieldRequired: required,
      fieldInvalid: invalid
    };
  }
  isInput(type) {
    return FieldTypes.input.indexOf(type) >= 0;
  }
  isCheckbox(type) {
    return FieldTypes.checkbox.indexOf(type) >= 0;
  }
  onFieldChanged(element, field) {
    // console.log('field changed', element, field);
  }
}



// WEBPACK FOOTER //
// ./client/components/simpleCrud/simpleCrud.controller.ts